import { useState } from "react";
import Navbar from "../../components/Navbar";
import NavTabs from "../../components/NavTabs";
import DashboardContainer from "../Dashboard/DashboardContainer";
import ActiveLoanComponent from "./component/ActiveLoanComponent";
import InProcessLoanComponent from "./component/InProcessLoanComponent";
import PastLoanComponent from "./component/PastLoanComponent";
import Carousel from "../../components/Carousel";
import StarIcon from "../../assets/Icons/StarIcon";
import Card from "../../components/Card";
import { Button } from "../../components/Buttons";
import Headings from "../../components/Texts/Headings";
import ApplyNowCard from "./component/ApplyNowCard";

const MyLoans = () => {
  const [loanStates, setLoanStates] = useState({
    activeTab: 1,
    activeLoanArray: [
      {
        loanType: "Personal Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        interest: "12%",
        loanDate: "3/4/2023",
        type: "upcoming",
        id: "VIK-ML-20241115-001",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      },
      {
        loanType: "Lifestyle Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        interest: "12%",
        type: "active",
        id: "VIK-ML-20241115-001",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      }, {
        loanType: "Medical Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        interest: "12%",
        type: "active",
        id: "VIK-ML-20241115-001",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      }
    ],
    inProcessLoanArray: [
      {
        loanType: "Home Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        interest: "12%",
        type: "processing",
        statusColor: "bg-[#FFF3C2] text-[#D9A004]",
        value: "Ongoing Credit Check",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      },
      {
        loanType: "Lifestyle Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        type: "Approved",
        interest: "12%",
        statusColor: "bg-[#FFDDDD] text-[#700E0E]",
        value: "Sign loan Agreement",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      },
    ],
    pastLoanArray: [
      {
        loanType: "Personal Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        interest: "12%",
        type: "completed",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        statusColor: "bg-[#D7F5FF] text-[#07453A]",
        value: "closed",
        totalEmi: "1/3"
      },
      {
        loanType: "Lifestyle Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        type: "completed",
        interest: "12%",
        loanDate: "3/4/2023",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        netEmiAmount: "5000",
        statusColor: "bg-[#FFDDDD] text-[#700E0E]",
        value: "rejected",
        totalEmi: "1/3"
      }, {
        loanType: "Medical Loan",
        totalAmount: "30000",
        tenure: "6 Months",
        type: "rejected",
        interest: "12%",
        loanDate: "3/4/2023",
        value: "Invalid Details",
        balance: "20000",
        nextEmiDate: "feb 5,2024",
        statusColor: "bg-[#FFDDDD] text-[#700E0E]",
        netEmiAmount: "5000",
        totalEmi: "1/3"
      }
    ]
  })
  const tabArray = [
    { label: "Active" },
    { label: "In Process" },
    { label: "Closed" }
  ];

  const stateChangeHandler = (key, value) => {
    setLoanStates((prevState) => ({
      ...prevState,
      [key]: value
    }))
  }

  const activeTabHandler = (tab) => {
    stateChangeHandler("activeTab", tab);
  }

  const loanService = [
    {
      title: "Personal Loan upto 5 Lac",
      iconClass: "text-[#6F4C9F]",
      bgClass: "bg-[#6F4C9F33]",
      text: "Congratulations Vikram, you can get upto Rs.5 lakh loan with 0 paperwork in 5 mins with FastFin "
    },
    {
      title: "Medical Loan",
      iconClass: "text-[#FECE07]",
      bgClass: "bg-[#FECE0733]",
      text: "Dear Vikram, Get Rs. 50,000 Loan Approved instantly on 26-03-2024."
    },
  ]

  return (<>
    <>
      <Navbar isLoggedIn={true} />
      {/*  <InstantLoanSection/> */}
      <DashboardContainer >
        <Headings
          text="My Loans"
        />
        {/* <h4 className="font-filson-soft font-[700] text-[36px] tracking-[-2%] leading-[40px]">My loans</h4> */}
        <NavTabs tabArray={tabArray}
          activeTab={loanStates?.activeTab}
          activeTabHandler={activeTabHandler}
          className="my-[24px]"
        />
        <div>
          <ApplyNowCard />
          {loanStates?.activeTab == 1 && <ActiveLoanComponent activeLoans={loanStates?.activeLoanArray} />}
          {loanStates?.activeTab == 2 && <InProcessLoanComponent inprocessLoans={loanStates?.inProcessLoanArray} />}
          {loanStates?.activeTab == 3 && <PastLoanComponent pastLoans={loanStates?.pastLoanArray} />}
        </div>
        {/* <div className="mt-[180px] flex flex-col gap-[24px]">
          <div className="max-w-[1000px]">
            <h4 className="font-filson-soft font-[700] text-[36px] tracking-[-2%] leading-[40px]">Loans Curated For You</h4>
          </div>
          <div className="grid grid-cols-3 gap-[20px]">
            {loanService?.map((item) => <Card className={" gap-[12px] col-span-1 p-[0px] grid grid-rows-2"}>
              <div className="px-[28px] py-[14px] flex flex-col gap-[48px] row-span-1">
                <StarIcon className={item?.iconClass} />
                <p className="font-Apparat font-[600] text-[32px] leading-[36px] tracking-[-2%]">{item?.title}</p>
              </div>
              <div className={`flex flex-col gap-[12px] py-[14px] px-[28px] h-full ${item?.bgClass} row-span-1 justify-between`}>
                <p className="font-Apparat font-[600] text-[14px] leading-[20px] tracking-[-2%]">{item?.text}</p>
                <Button
                  title="Apply Now"
                  variant="secondary"
                  className="text-primary"
                />
              </div>
            </Card>)}
          </div>
        </div> */}
        {/* <div className="mt-[160px]">
          <Carousel />
        </div> */}
      </DashboardContainer>
    </>
  </>)
}
export default MyLoans; 